import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { api, brl } from "@/lib/api";
import { vehicleShort } from "@/lib/waTemplates";
import { Loader2, Download, CheckCircle2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export function useShareLink(orderId, enabled = true) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!orderId || !enabled) { return; }
    api.post(`/orders/${orderId}/share-link`).then(({ data }) => setUrl(data.url)).catch(() => setUrl(""));
  }, [orderId, enabled]);
  return url;
}

export default function PublicShare() {
  const { code } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    axios.get(`${API}/api/p/${code}/data`).then(({ data }) => setD(data)).catch(() => setErr("Este link expirou ou não é válido. Peça um novo à oficina."));
  }, [code]);
  if (err) return <div data-testid="share-error" className="min-h-dvh flex items-center justify-center p-6 text-center text-zinc-300">{err}</div>;
  if (!d) return <div className="min-h-dvh flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-green-brand" /></div>;
  const b = d.budget;
  const color = d.shop.brand_color || "#16a34a";
  return (
    <div className="min-h-dvh bg-appbg px-4 py-6" data-testid="public-share">
      <div className="max-w-xl mx-auto space-y-4">
        <header className="flex items-center gap-3">
          {d.shop.logo_url && <img src={d.shop.logo_url} alt="" className="h-12 w-12 rounded-xl object-contain bg-white" />}
          <div><div className="font-display text-xl font-black uppercase text-zinc-100">{d.shop.name}</div>
            <div className="text-xs text-zinc-400">Orçamento{d.order_number ? ` · OS #${d.order_number}` : ""}{d.no_vehicle ? "" : ` · ${vehicleShort(d)} ${d.plate || ""}`}</div></div>
        </header>
        {!b ? <p className="text-zinc-400">O orçamento ainda não foi preparado.</p> : (
          <section className="rounded-2xl border border-card2-border bg-card2 overflow-hidden">
            <ul className="divide-y divide-zinc-800">{b.items.map((it, i) => (
              <li key={i} data-testid={`share-item-${i}`} className="p-3">
                <div className="flex justify-between gap-2 text-sm"><span className="text-zinc-100">{it.description}</span><span className="text-zinc-200 font-bold whitespace-nowrap">{brl((Number(it.quantity) || 0) * (Number(it.unit_price) || 0) - (Number(it.discount) || 0))}</span></div>
                <div className="text-[11px] text-zinc-500">{it.quantity} × {brl(it.unit_price)}{Number(it.discount) > 0 ? ` − desconto ${brl(it.discount)}` : ""}</div>
                {it.explanation && <p className="mt-1 text-xs text-zinc-400">{it.explanation}</p>}
              </li>))}</ul>
            <div className="flex items-center justify-between p-4 bg-zinc-900"><span className="text-xs font-mono-caps text-zinc-400">Total</span><span data-testid="share-total" className="font-display text-2xl font-black" style={{ color }}>{brl(b.total)}</span></div>
          </section>
        )}
        {b?.decision === "aprovado" && <p className="flex items-center gap-2 text-green-300 text-sm"><CheckCircle2 className="h-4 w-4" /> Orçamento aprovado.</p>}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {b?.decision === "pendente" && <Link data-testid="share-approve" to={`/cliente/ordens/${d.order_id}`} className="h-12 rounded-xl flex items-center justify-center font-bold text-white" style={{ background: color }}>Aprovar ou recusar</Link>}
          {b && <a data-testid="share-pdf" href={`${API}/api/p/${code}/pdf`} target="_blank" rel="noopener noreferrer" className="h-12 rounded-xl border border-zinc-700 flex items-center justify-center gap-2 text-zinc-100 font-bold"><Download className="h-4 w-4" /> Baixar PDF</a>}
        </div>
        <p className="text-[11px] text-zinc-500">Link válido até {new Date(d.expires_at).toLocaleString("pt-BR")}. Para aprovar, entre com seu acesso de cliente.</p>
      </div>
    </div>
  );
}
